export const Volumes = {
  volumes: 'Nº de Volumes',
  pallets: 'Nº de Paletes',
  equivalents: 'Nº de Paletes Equivalentes'
}



// WEBPACK FOOTER //
// ./src/translations/pt/components/Volumes.js